import Vue from 'vue';
import { commonTransfersHistoryTablesMixin } from '@/components/pages/transfersPage/components/transfersHistory/mixins/index';
export default Vue.extend({
    name: 'bonusesPayoutTable',
    props: {
        items: {
            type: Array,
            required: true
        }
    },
    mixins: [
        commonTransfersHistoryTablesMixin
    ],
    data() {
        return {
            headers: [
                {
                    id: 1,
                    switched: true,
                    text: this.$t('transfersPage.history.bonusesTable.payoutType'),
                    align: 'start',
                    sortable: true,
                    value: 'payoutType',
                    width: 140,
                    priority: 1
                },
                {
                    id: 2,
                    switched: true,
                    text: this.$t('transfersPage.history.bonusesTable.datetime'),
                    align: 'start',
                    sortable: true,
                    value: 'datetime',
                    width: 120,
                    priority: 2
                },
                {
                    id: 3,
                    switched: true,
                    text: this.$t('transfersPage.history.bonusesTable.amount'),
                    align: 'end',
                    sortable: true,
                    value: 'amount',
                    width: 184,
                    priority: 1
                },
                {
                    id: 4,
                    switched: true,
                    text: this.$t('transfersPage.history.bonusesTable.asset'),
                    align: 'start',
                    sortable: true,
                    value: 'asset',
                    width: 0,
                    priority: 1
                }
            ],
            sorting: '',
            isDescSort: false,
            scrolledDown: false
        };
    },
    computed: {
        headersByPriority() {
            const vm = this;
            let currPriority = 4;
            if (vm.$root.windowWidth <= 960 && vm.$root.windowWidth >= 768)
                currPriority = 3;
            if (vm.$root.windowWidth < 768 && vm.$root.windowWidth >= 516)
                currPriority = 2;
            if (vm.$root.windowWidth < 516)
                currPriority = 1;
            return vm.headers.reduce((acc, curr) => {
                if (curr.priority <= currPriority) {
                    if (currPriority === 1) {
                        if (curr.value === 'payoutType') {
                            curr.width = 78;
                        }
                        if (curr.value === 'amount') {
                            curr.width = 0;
                        }
                        if (curr.value === 'asset') {
                            curr.width = 40;
                            curr.text = '';
                        }
                    }
                    else if (currPriority === 2) {
                        if (curr.value === 'payoutType') {
                            curr.width = 100;
                        }
                        if (curr.value === 'datetime') {
                            curr.width = 108;
                        }
                        if (curr.value === 'amount') {
                            curr.width = 0;
                        }
                        if (curr.value === 'asset') {
                            curr.width = 40;
                            curr.text = '';
                        }
                    }
                    else if (currPriority === 3) {
                        if (curr.value === 'payoutType') {
                            curr.width = 100;
                        }
                        if (curr.value === 'datetime') {
                            curr.width = 108;
                        }
                        if (curr.value === 'amount') {
                            curr.width = 253;
                        }
                        if (curr.value === 'asset') {
                            curr.width = 0;
                            curr.text = '';
                        }
                    }
                    else {
                        if (curr.value === 'payoutType') {
                            curr.width = 140;
                        }
                        if (curr.value === 'datetime') {
                            curr.width = 120;
                        }
                        if (curr.value === 'amount') {
                            curr.width = 184;
                        }
                        if (curr.value === 'asset') {
                            curr.width = 0;
                            curr.text = this.$t('transfersPage.history.bonusesTable.asset');
                        }
                    }
                    acc.push(curr);
                }
                return acc;
            }, []);
        }
    },
    mounted() {
        // const vm = this as any
        // const { thead, tbody } = vm.$refs
        // function setSameWidth () {
        //   const tbodyCells = tbody.$el.querySelectorAll('tbody tr:first-of-type td')
        //   const theadCells = thead.$el.querySelectorAll('thead tr th')
        //   if (tbodyCells) {
        //     for (let i = 0; i < tbodyCells.length; i++) {
        //       let width = parseFloat(window.getComputedStyle(theadCells[i]).maxWidth)
        //       if (width > 200) width = 200
        //       theadCells[i].setAttribute('width', width)
        //       tbodyCells[i].setAttribute('width', width)
        //       tbodyCells[i].style.width = width + 'px'
        //       tbodyCells[i].style.maxWidth = width + 'px'
        //       tbodyCells[i].style.minWidth = width + 'px'
        //     }
        //   }
        // }
        // if (window.innerWidth > 767 && vm.items.length) {
        //   setSameWidth()
        //   const tbodyObserver = new MutationObserver(setSameWidth)
        //   tbodyObserver.observe(thead.$el, {
        //     childList: true,
        //     subtree: true,
        //     characterData: true
        //   })
        //   window.addEventListener('resize', setSameWidth)
        // }
    }
});
